import { environment } from './../../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, EventEmitter} from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DireccionesService {
  private headers: HttpHeaders;
  public modalSwitch: boolean;
  public modalCustomPrice: boolean;
  $modal = new EventEmitter<any>();
  $modalCustomPrice = new EventEmitter<any>();
  constructor(private http:HttpClient) { }
  
  obtenerDireccion(id:number):Observable<any>{
    return this.http.get<any>(environment.API_SECURITY+'/api/DireccionesCliente/DireccionById/'+id)
  }

  obtenerMensajes(): Observable<any[]> {
		return this.http.get<any[]>(`${environment.API_SECURITY}/api/DireccionesCliente/listaDirecciones`);
	}

  agregarDireccion(formdata) {
		return this.http.post(environment.API_SECURITY + '/api/DireccionesCliente', formdata);
	}

  actualizarDireccion(formData): Observable<any> {
		return this.http.put<any>(environment.API_SECURITY + '/api/DireccionesCliente', formData);
	} 
  
  eliminarDireccion(id: Number) {
		return this.http.delete(environment.API_SECURITY + '/api/DireccionesCliente/' + id);
	}

  cambiarEstatus(id) {
    return this.http.get(environment.API_SECURITY + '/api/DireccionesCliente/cambiarEstatus/' + id); 
  }
  
  obtenerDireccionPredeterminada(): Observable<any> {
		return this.http.get<any>(`${environment.API_SECURITY}/api/DireccionesCliente/DireccionPredeterminada`);
	}  

  getDirectionCp(codigoPostal: string) {
		return this.http.get<any>(`${environment.API_SECURITY}/api/DireccionesCP/${codigoPostal}`);
  }


}
